import { useRouter } from 'vue-router'
import { clearToken } from '@/utils'

export function useLogout () {
  const router = useRouter()

  function logout () {
    clearToken()
    router.push('/login')
  }

  return { logout }
}
